import { RpcSmeExtensionRequest } from './rpc-sme-extension-model';

/**
 * Rpc extension request sever side handler interface.
 */
export interface RpcSmeExtensionRequestHandler {
    handler(data: RpcSmeExtensionRequest): Promise<void>;
}
